import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { environment } from 'environments/environment';

import { AssessmentAnswerInterface, AssessmentQuestionInterface } from 'app/assessment/models';
import { DynamicQuestionComponent } from 'app/assessment/questions/dynamic-question-content/dynamic-question.component';
import { MceSettings } from 'app/core/mce-config/mce-editor-config.constant';
import { getDeepCopyOfObject } from 'app/shared/utilities/utility-methods.utility';


@Component({
  selector: 'cz-executive-summary',
  templateUrl: './executive-summary.component.html',
  styleUrls: ['./executive-summary.component.scss'],
})
export class ExecutiveSummaryComponent extends DynamicQuestionComponent implements OnInit {
  @Input() public readonly type: string;
  @Input() public readonly question: AssessmentQuestionInterface;
  @Input() public readonly form: FormGroup;
  @Input() public readonly imagePath: string;
  @Input() public readonly parentQuestion: AssessmentQuestionInterface;
  @Input() public readonly readOnly: boolean;
  public tinyApiKey: string = environment.tinyMceKey;
  public mceConfig: any = MceSettings.default;
  public initialValue: string;

  constructor() {
    super();
    this.mceConfig = { ...this.mceConfig, height: 330 };
  }

  public ngOnInit(): void {
    if (this.question && this.question.answers[0].text) {
      this.initialValue = atob(this.question.answers[0].text);
    }
  }

  public onEditorChange(value: any, formControlName: number, answer: AssessmentAnswerInterface): void {
    const encodedValue: string = btoa(value.editor.getContent());
    const formGroup: FormGroup = this.form.controls[this.type] as FormGroup;
    const updatedAnswer: AssessmentAnswerInterface = getDeepCopyOfObject(answer);
    updatedAnswer.text = encodedValue;

    formGroup.controls[formControlName].setValue(updatedAnswer);
    formGroup.markAsDirty();
  }

}
